import Spacings from "../../../../../../packages/design-system/src/Spacings";
import OrigStarIcon from "../../../../../../packages/design-system/src/Icons/svg/star.svg";
import Rating from "../../../../../../packages/design-system/src/Rating";
import * as React from 'react';
export default {
  Spacings,
  OrigStarIcon,
  Rating,
  React
};